<template>
  <div id="adminContainer">
    <div class="inner" style="max-height: calc(100vh - 50px); overflow-y: auto">
      <div
        style="
          width: 6px;
          height: 20px;
          background: #464775;
          float: left;
          margin-right: 10px;
        "
      ></div>
      <div style="float: left; position: relative; top: -4px">
        <h3 class="pr-3" style="font-weight: 600">통계</h3>
      </div>
      <div
        style="
          clear: both;
          width: 99%;
          height: 2.5px;
          background-color: #e9e9e9;
        "
      ></div>
      <!--tabContent-->
      <div class="tabContent" style="margin-top: 40px">
        <v-layout row>
          <v-flex xs12 style="padding: 3px !important; margin-left: 15px">
            <div
              class="analytics-btn"
              @click="
                active = 'meetingInfo';
                activeChanged();
              "
            >
              회의현황
            </div>
            <div
              class="analytics-btn"
              @click="
                active = 'meetingStatistics';
                activeChanged();
              "
            >
              회의통계
            </div>
          </v-flex>
        </v-layout>
        <!--tabs-1 -->
        <div id="tabs-1" class="tabPage" v-if="meetingUsageTab">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 30px 0 15px 12px;
            "
          >
            <div class="inputbox">
              <input
                class="search-inputbox"
                style="width: 150px"
                type="text"
                placeholder="개설자"
                v-model="filter.creator"
                @keyup.enter="searchMeeting()"
              />
              <input
                class="search-inputbox"
                style="width: 150px"
                type="text"
                placeholder="회의명"
                v-model="filter.title"
                @keyup.enter="searchMeeting()"
              />
              <div class="date" style="display: flex; align-items: center">
                <date-picker
                  v-model="filter.startDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :lang="lang"
                  style="width: 125px; height: 30px; font-size: 13px"
                ></date-picker>

                <span
                  class="hyphen"
                  style="margin: 0 5px; padding-top: 0; color: #333"
                  >~</span
                >
                <date-picker
                  v-model="filter.endDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :lang="lang"
                  style="width: 125px; height: 30px; font-size: 13px"
                  :disabled-date="notBeforeStartDate"
                ></date-picker>
              </div>
              <button class="btnPrimary" @click="searchMeeting()">검색</button>
            </div>
            <img
              src="/static/seoul/img/excel.png"
              style="width: 30px; margin-right: 10px; cursor: pointer"
              @click="exportMeetingList()"
            />
          </div>
          <!--//tab_Top-->
          <div class="tbw_tb01">
            <table>
              <caption>
                회의리스트
              </caption>
              <thead>
                <tr>
                  <th style="cursor: pointer" @click="sortDate()">
                    회의날짜<v-icon color="gray">{{
                      dateSort === 'desc' ? 'arrow_upward' : 'arrow_downward'
                    }}</v-icon>
                  </th>
                  <th>회의 예약 시간</th>
                  <th>회의명</th>
                  <th>개설자</th>
                  <th style="cursor: pointer" @click="sortDept()">부서</th>
                  <th>미팅키</th>
                  <th>총 초대자</th>
                  <th>영상장비</th>
                  <!-- <th>초대자</th> -->
                  <th>참석자</th>
                  <th>참여 정보</th>
                  <th>유형</th>
                  <th>부가기능</th>
                  <th>망구분</th>
                </tr>
              </thead>
              <caption>
                이 표는 구성되어 있습니다.
              </caption>
              <colgroup>
                <col style="width: 7%" />
                <col style="width: 7%" />
                ``
                <col style="width: 23%" />
                <col style="width: 6%" />
                <col style="width: 10%" />
                <col style="width: 8%" />
                <col style="width: 5%" />
                <col style="width: 5%" />
                <col style="width: 5%" />
                <!-- <col style="width:5%;" /> -->
                <col style="width: 5%" />
                <col style="width: 4%" />
                <col style="width: 13%" />
                <col style="width: 7%" />
              </colgroup>
              <tbody>
                <tr
                  v-for="(listItem, index) in filterLimitMeeting"
                  :key="index"
                >
                  <td>
                    <span>{{ listItem.startDtime | conferenceDayFilter }}</span>
                  </td>
                  <td>
                    <span
                      >{{ listItem.startDtime | conferenceTimeFilter }} ~
                      {{ listItem.endDtime | conferenceTimeFilter }}</span
                    >
                  </td>
                  <td>{{ listItem.title }}</td>
                  <td>
                    {{
                      listItem.creator.username
                        ? listItem.creator.username
                        : listItem.creator.name
                    }}
                  </td>
                  <td>{{ listItem.creator.deptName }}</td>
                  <td>{{ listItem.meetingKey }}</td>
                  <td>
                    {{ listItem.attendees ? listItem.attendees.length : '0' }}
                  </td>
                  <td>
                    {{
                      listItem.analytics
                        ? listItem.analytics.participantType.codec
                        : '0'
                    }}
                  </td>
                  <td>
                    {{
                      listItem.analytics
                        ? listItem.analytics.participantType.pc
                        : '0'
                    }}
                  </td>
                  <!-- <td>{{ listItem.analytics.participantType.mobile }}</td> -->
                  <!-- <td>{{ listItem.history.length }}</td> -->
                  <td>
                    <a
                      class="icocom info_ico"
                      @click="attendInfo(listItem)"
                    ></a>
                  </td>
                  <td>
                    {{ listItem.conferenceRoomActive ? '고화질' : '일반' }}
                  </td>
                  <td>
                    {{ listItem.meetingLog ? 'AI회의록' : null }}
                    {{ listItem.allPublicMeeting ? '/ 전체 공개회의' : null }}
                    {{ listItem.isPrivate ? '/ 비밀번호' : null }}
                    {{ listItem.exMeeting ? '/ 인터넷망 전용' : null }}
                  </td>
                  <td>
                      {{ listItem.exMeeting === true ? '인터넷망' : '업무망' }}
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--total_num-->
          <div class="total_num" style="margin-right: 28px">
            <p class="fl" style="padding-top: 5px">
              <span>전체 영상회의 수 :</span
              ><span>{{ meetingList.length }}</span>
            </p>
          </div>
          <!--total_num-->
          <!--//tbw_tb01-->
          <div class="paging">
            <div class="boardnavi">
              <pagination
                :records="meetingList.length"
                v-model="page"
                :per-page="perPage"
              />
            </div>
          </div>
        </div>
        <!--//tabs-1 -->

        <div id="tabs-2" class="tabPage" v-if="meetingStatistics">
          <div class="tab_Top" style="z-index: 2; margin-top: 20px"></div>

          <!--graphBox-->
          <div class="graphBox">
            <!--gp_row -->
            <div class="gp_row">
              <div>
                <div
                  class="tit"
                  style="
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <h5 class="pr-3" style="font-weight: 600">
                    일별 영상회의 현황
                  </h5>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div class="date" style="display: flex">
                      <date-picker
                        v-model="filter.dayStartDate"
                        format="YYYY-MM"
                        value-type="format"
                        type="month"
                        :lang="lang"
                        style="width: 125px; height: 30px; font-size: 13px"
                      ></date-picker>

                      <!-- <span
                        class="hyphen"
                        style="margin: 0 5px; padding-top: 0; color: #333"
                        >~</span
                      >
                      <date-picker
                        v-model="filter.dayEndDate"
                        format="YYYY-MM"
                        value-type="format"
                        type="month"
                        :lang="lang"
                        style="width: 125px; height: 30px; font-size: 13px"
                        :disabled-date="notBeforeStartDate"
                      ></date-picker> -->
                      <!-- <div class="date_ck">
                        <span @click="showDatePicker('day')">{{ filter.dayStartDate | conferenceDayFilter }}</span>
                        <v-date-picker
                          v-bind:style="{display:isActive.day}"
                          v-model="filter.dayStartDate" 
                          :allowed-dates="allowedStartDates"
                          no-title 
                          scrollable
                          :locale="$i18n.locale ? $i18n.locale : 'kr'"
                          @change="startDateChange('day')"
                        >
                        </v-date-picker>
                      </div>
                      <span class="hyphen">~</span>
                      <div class="date_ck">
                        <span @click="showEndDatePicker('day')">{{ filter.dayEndDate | conferenceDayFilter }}</span>
                        <v-date-picker
                          v-bind:style="{display:isEndActive.day}"
                          v-model="filter.dayEndDate" 
                          :allowed-dates="allowedEndDates"
                          no-title 
                          scrollable
                          :locale="$i18n.locale ? $i18n.locale : 'kr'"
                          @change="endDateChange('day')"
                        >
                        </v-date-picker>
                      </div> -->
                    </div>
                    <div class="search_top inblk">
                      <button
                        class="btnPrimary"
                        @click="searchStatictis('day')"
                      >
                        검색
                      </button>
                    </div>
                  </div>
                </div>
                <div class="graphimg">
                  <e-chart
                    ref="dayMeetingChart"
                    :path-option="[
                      ['dataset.source', dayMeetingData],
                      ['color', [colorDefined.codec, colorDefined.pcMobile]],
                      ['legend.show', true],
                      ['legend.show', true],
                      ['xAxis.axisLabel.show', true],
                      ['yAxis.axisLabel.show', true],
                      ['grid.left', '2%'],
                      ['grid.bottom', '5%'],
                      ['grid.right', '3%'],
                      ['series[0].type', 'bar'],
                      ['series[0].areaStyle', {}],
                      ['series[0].smooth', true],
                      ['series[1].type', 'bar'],
                      ['series[1].areaStyle', {}],
                      ['series[1].smooth', true],
                    ]"
                    height="400px"
                    width="100%"
                  >
                  </e-chart>
                </div>
              </div>
            </div>
            <!--//gp_row -->

            <!--gp_row -->
            <div class="gp_row">
              <div>
                <div
                  class="tit"
                  style="
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <h5 class="pr-3" style="font-weight: 600">
                    주간별 영상회의 현황
                  </h5>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div
                      class="date"
                      style="display: flex; align-items: center"
                    >
                      <date-picker
                        v-model="filter.weekStartDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        :lang="lang"
                        style="width: 125px; height: 30px; font-size: 13px"
                        @change="onStartDateChange"
                      ></date-picker>

                      <span
                        class="hyphen"
                        style="margin: 0 5px; padding-top: 0; color: #333"
                        >~</span
                      >
                      <date-picker
                        v-model="filter.weekEndDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        :lang="lang"
                        style="width: 125px; height: 30px; font-size: 13px"
                        :disabled="true"
                      ></date-picker>
                    </div>
                    <div class="search_top inblk">
                      <button
                        class="btnPrimary"
                        @click="searchStatictis('week')"
                      >
                        검색
                      </button>
                    </div>
                  </div>
                </div>
                <div class="graphimg">
                  <e-chart
                    ref="weekDayMeetingChart"
                    :path-option="[
                      ['dataset.source', weekDayMeetingData],
                      ['color', [colorDefined.codec, colorDefined.pcMobile]],
                      ['legend.show', true],
                      ['legend.show', true],
                      ['xAxis.axisLabel.show', true],
                      ['yAxis.axisLabel.show', true],
                      ['grid.left', '2%'],
                      ['grid.bottom', '5%'],
                      ['grid.right', '3%'],
                      ['series[0].type', 'bar'],
                      ['series[0].areaStyle', {}],
                      ['series[0].smooth', true],
                      ['series[1].type', 'bar'],
                      ['series[1].areaStyle', {}],
                      ['series[1].smooth', true],
                    ]"
                    height="400px"
                    width="100%"
                  >
                  </e-chart>
                </div>
              </div>
              <div>
                <div
                  class="tit"
                  style="
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <h5 class="pr-3" style="font-weight: 600">
                    월별 영상회의 현황
                  </h5>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div class="date" style="display: flex">
                      <date-picker
                        v-model="filter.monthStartDate"
                        format="YYYY-MM"
                        value-type="format"
                        type="month"
                        :lang="lang"
                        style="width: 125px; height: 30px; font-size: 13px"
                      ></date-picker>
                    </div>
                    <div class="search_top inblk">
                      <button
                        class="btnPrimary"
                        @click="searchStatictis('month')"
                      >
                        검색
                      </button>
                    </div>
                  </div>
                </div>
                <div class="graphimg">
                  <e-chart
                    ref="monthMeetingChart"
                    :path-option="[
                      ['dataset.source', monthMeetingData],
                      ['color', [colorDefined.codec, colorDefined.pcMobile]],
                      ['legend.show', true],
                      ['legend.show', true],
                      ['xAxis.axisLabel.show', true],
                      ['yAxis.axisLabel.show', true],
                      ['grid.left', '2%'],
                      ['grid.bottom', '5%'],
                      ['grid.right', '3%'],
                      ['series[0].type', 'bar'],
                      ['series[0].areaStyle', {}],
                      ['series[0].smooth', true],
                      ['series[1].type', 'bar'],
                      ['series[1].areaStyle', {}],
                      ['series[1].smooth', true],
                    ]"
                    height="400px"
                    width="100%"
                  >
                  </e-chart>
                </div>
              </div>
              <div style="margin-right: 50px">
                <div
                  class="tit"
                  style="
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <h5 class="pr-3" style="font-weight: 600">
                    시간별 접속자 현황
                    <span
                      style="color: brown; font-size: 13px; font-weight: 300"
                      >(최대 {{ timeData.max }}, 평균
                      {{ timeData.average.toFixed(1) }}, 최소
                      {{ timeData.min }})</span
                    >
                  </h5>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div class="date" style="display: flex">
                      <date-picker
                        v-model="filter.timeStartDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        :lang="lang"
                        style="width: 125px; height: 30px; font-size: 13px"
                        :disabled-date="disabledTodayAndFuture"
                        @change="onStartDateChange"
                      ></date-picker>
                    </div>
                    <div class="search_top inblk">
                      <button
                        class="btnPrimary"
                        @click="searchStatictis('time')"
                      >
                        검색
                      </button>
                    </div>
                  </div>
                </div>
                <div class="graphimg">
                  <e-chart
                    ref="timeMeetingChart"
                    :path-option="[
                      ['dataset.source', timeMeetingData],
                      [
                        'color',
                        [
                          colorDefined.codec,
                          colorDefined.pcMobile,
                          colorDefined.codecPcMobile,
                        ],
                      ],
                      ['legend.show', true],
                      ['xAxis.axisLabel.show', true],
                      ['yAxis.axisLabel.show', true],
                      ['grid.left', '2%'],
                      ['grid.bottom', '5%'],
                      ['grid.right', '3%'],

                      ['series[0].type', 'line'],
                      ['series[0].smooth', true],
                      ['series[1].type', 'line'],
                      ['series[1].smooth', true],
                      ['series[2].type', 'line'],
                      ['series[2].smooth', true],
                    ]"
                    height="400px"
                    width="100%"
                  >
                  </e-chart>
                  <!-- <div class="sc">
                    <span class="sc_text"><b class="circle"></b>회의실 별 현황</span>
                  </div>
                  <img src="/static/webex-cloud/images/graph01.png" alt="샘플그래프"> -->
                </div>
              </div>
            </div>
            <!--//gp_row -->

            <!-- <div style="position: absolute;bottom:10px;right:0">
            <a class="exel fl" style="margin-left: 20px">EXPORT</a>
          </div> -->
          </div>
          <!--//graphBox-->
        </div>
        <!--//tabs-2 -->

        <!--tabs-3 -->
        <div id="tabs-3" class="tabPage" v-if="meetingTermList">
          <!--tab_Top-->
          <div class="tab_Top">
            <!--datewrap-->
            <div class="datewrap">
              <!--date -->
              <div class="date">
                <div class="date_ck">
                  <span @click="showDatePicker">{{
                    filter.startDate | conferenceDayFilter
                  }}</span>
                  <v-date-picker
                    v-bind:style="{ display: isActive }"
                    v-model="filter.startDate"
                    :allowed-dates="allowedStartDates"
                    no-title
                    scrollable
                    :locale="$i18n.locale ? $i18n.locale : 'kr'"
                    @change="startDateChange"
                  >
                  </v-date-picker>
                </div>
                <span class="hyphen">~</span>
                <div class="date_ck">
                  <span @click="showEndDatePicker">{{
                    filter.endDate | conferenceDayFilter
                  }}</span>
                  <v-date-picker
                    v-bind:style="{ display: isEndActive }"
                    v-model="filter.endDate"
                    :allowed-dates="allowedEndDates"
                    no-title
                    scrollable
                    :locale="$i18n.locale ? $i18n.locale : 'kr'"
                    @change="endDateChange"
                  >
                  </v-date-picker>
                </div>
              </div>
              <!--//date -->

              <!--searchbox -->
              <div class="searchbox">
                <div class="search_top inblk">
                  <button
                    type="submit"
                    class="search_btn"
                    @click="searchUsageRoom()"
                  >
                    <div class="search-txt">검색</div>
                  </button>
                </div>
              </div>
              <!--//searchbox -->
            </div>
            <!--datewrap-->
          </div>
          <!--//tab_Top-->

          <!--tbw_tb01-->
          <div class="tbw_tb01">
            <v-data-table
              :headers="getRoomMeetingUsageHeaders()"
              :items="roomUsageMeetings"
              :loading="loading"
              :rows-per-page-items="pageItem"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <!-- <td class="text-xs-center">{{ props.item.groupName }}</td> -->
                <td class="text-xs-center">{{ props.item.buildingName }}</td>
                <td class="text-xs-center">{{ props.item.roomName }}</td>
                <!-- <td class="text-xs-center">{{ props.item.floor }}</td> -->
                <td class="text-xs-center">{{ props.item.capacity }}</td>
                <td class="text-xs-center">{{ props.item.createdCnt }}</td>
                <td class="text-xs-center">{{ props.item.totalDuration }}</td>
              </template>
            </v-data-table>
            <!--total_num-->
          </div>
          <!--//tbw_tb01-->

          <!--//tbw_tb01-->
          <div class="paging" style="padding-left: 70px">
            <div class="boardnavi">
              <pagination
                :records="usageRoomList.length"
                v-model="page"
                :per-page="perPage"
              />
            </div>
          </div>
        </div>

        <!--tabs-4 -->
        <div id="tabs-4" class="tabPage" v-if="messengerMeetingUsageTab">
          <!--tab_Top-->
          <div class="tab_Top" style="margin-top: 50px">
            <!--datewrap-->
            <div class="datewrap" style="margin-left: 16px">
              <!--inputbox-->
              <div class="inputbox">
                <span class="input_filter_txt"
                  ><input
                    type="text"
                    placeholder="개설자"
                    v-model="filter.creator"
                /></span>
                <span class="input_filter_txt"
                  ><input
                    type="text"
                    placeholder="회의명"
                    v-model="filter.title"
                /></span>
              </div>
              <!--//inputbox-->

              <!--date -->
              <div class="date">
                <div class="date_ck">
                  <span @click="showDatePicker">{{
                    filter.startDate | conferenceDayFilter
                  }}</span>
                  <v-date-picker
                    v-bind:style="{ display: isActive }"
                    v-model="filter.startDate"
                    :allowed-dates="allowedStartDates"
                    no-title
                    scrollable
                    :locale="$i18n.locale ? $i18n.locale : 'kr'"
                    @change="startDateChange"
                  >
                  </v-date-picker>
                </div>
                <span class="hyphen">~</span>
                <div class="date_ck">
                  <span @click="showEndDatePicker">{{
                    filter.endDate | conferenceDayFilter
                  }}</span>
                  <v-date-picker
                    v-bind:style="{ display: isEndActive }"
                    v-model="filter.endDate"
                    :allowed-dates="allowedEndDates"
                    no-title
                    scrollable
                    :locale="$i18n.locale ? $i18n.locale : 'kr'"
                    @change="endDateChange"
                  >
                  </v-date-picker>
                </div>
              </div>
              <!--//date -->

              <!--searchbox -->
              <div class="searchbox">
                <div class="search_top inblk">
                  <button
                    type="submit"
                    class="search_btn"
                    @click="searchMeeting()"
                  >
                    <div class="search-txt">검색</div>
                  </button>
                </div>
              </div>
              <!--//searchbox -->
              <img
                src="/static/seoul/img/excel.png"
                style="float: right; width: 30px; cursor: pointer"
                @click="exportMeetingList()"
              />
            </div>
            <!--datewrap-->
          </div>
          <!--//tab_Top-->
          <div class="tbw_tb01">
            <table>
              <caption>
                회의리스트
              </caption>
              <thead>
                <tr>
                  <th style="cursor: pointer" @click="sortDate()">
                    회의날짜<v-icon color="gray">{{
                      dateSort === 'desc' ? 'arrow_upward' : 'arrow_downward'
                    }}</v-icon>
                  </th>
                  <th>회의 예약 시간</th>
                  <th>회의명</th>
                  <th>개설자</th>
                  <!-- <th>초대자</th> -->
                  <th>참석자</th>
                  <th>참여 정보</th>
                </tr>
              </thead>
              <caption>
                이 표는 구성되어 있습니다.
              </caption>
              <colgroup>
                <col style="width: 10%" />
                <col style="width: 10%" />
                <col style="width: 40%" />
                <col style="width: 10%" />
                <col style="width: 5%" />
                <!-- <col style="width:5%;" /> -->
                <col style="width: 5%" />
              </colgroup>
              <tbody>
                <tr
                  v-for="(listItem, index) in filterLimitMeeting"
                  :key="index"
                >
                  <td>
                    <span>{{ listItem.startDtime | conferenceDayFilter }}</span>
                  </td>
                  <td>
                    <span
                      >{{ listItem.startDtime | conferenceTimeFilter }} ~
                      {{ listItem.endDtime | conferenceTimeFilter }}</span
                    >
                  </td>
                  <td>{{ listItem.title }}</td>
                  <td>{{ listItem.creator.username }}</td>
                  <td>{{ listItem.analytics.participantType.pc }}</td>
                  <!-- <td>{{ listItem.analytics.participantType.mobile }}</td> -->
                  <!-- <td>{{ listItem.history.length }}</td> -->
                  <td>
                    <a
                      class="icocom info_ico"
                      @click="attendInfo(listItem)"
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--total_num-->
          <div class="total_num" style="margin-right: 28px">
            <p class="fl" style="padding-top: 5px">
              <span>전체 영상회의 수 :</span
              ><span>{{ meetingList.length }}</span>
            </p>
          </div>
          <!--total_num-->
          <!--//tbw_tb01-->
          <div class="paging">
            <div class="boardnavi">
              <pagination
                :records="meetingList.length"
                v-model="page"
                :per-page="perPage"
              />
            </div>
          </div>
        </div>
        <!--//tabs-4 -->
      </div>
      <!--//tabContent-->
    </div>

    <attending-info-dialog
      :dialog="attendingInfoDialog.dialog"
      :meeting="attendingInfoDialog.meeting"
      :closeDialog="closeAttendingInfoDialog"
    />
    <info-dialog
      :dialog="infoDialog.dialog"
      :title="infoDialog.title"
      :content="infoDialog.content"
      :closeDialog="closeInfoDialog"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import timezone from 'moment-timezone';
import EChart from '@/components/chart/echart';
import Material from 'vuetify/es5/util/colors';
import AttendingInfoDialog from '@/components/popup/AttendingInfoDialog';
import InfoDialog from '@/components/popup/InfoDialog';
import Pagination from 'vue-pagination-2';
import Util from '@/util';
import VueEnglishdatepicker from 'vue-englishdatepicker';
import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';

const range = (start, end) =>
  new Array(end - start).fill(start).map((el, i) => start + i);
const shortMonth = [
  '1월',
  '2월',
  '3월',
  '4월',
  '5월',
  '6월',
  '7월',
  '8월',
  '9월',
  '10월',
  '11월',
  '12월',
];

const dayShortNames = ['일', '월', '화', '수', '목', '금', '토'];

export default {
  filters: {
    conferenceDayFilter: function (day) {
      return moment(day).format('YYYY.MM.DD');
    },
    conferenceTimeFilter: function (time) {
      return moment(time).format('HH:mm');
    },
  },
  components: {
    AttendingInfoDialog,
    InfoDialog,
    EChart,
    Pagination,
    DatePicker,
    VueEnglishdatepicker,
  },
  data: () => ({
    active: 'meetingInfo',
    page: 1,
    perPage: 7,
    usageRoomPage: 1,
    loading: true,
    pageItem: [10, 20, 50],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
    },
    timeData: {
      max: 3,
      average: 3,
      min: 3,
    },
    dateSort: 'desc',
    deptSort: 'desc',
    meetingUsageTab: false,
    meetingStatistics: false,
    meetingTermList: false,
    messengerMeetingUsageTab: false,
    statisticsList: [
      { id: 'meetingUsageTab', title: '회의사용조회', isActive: false },
      { id: 'meetingStatistics', title: '회의통계', isActive: false },
      // { id: 'meetingTermList', title: '회의실 기간별 회의현황', isActive: false },
    ],
    filter: {
      title: null,
      creator: null,
      startDate: moment().add(-7, 'day').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      dayStartDate: moment().format('YYYY-MM'),
      dayEndDate: moment().format('YYYY-MM-DD'),
      weekStartDate: moment().add(-7, 'day').format('YYYY-MM-DD'),
      weekEndDate: moment().format('YYYY-MM-DD'),
      monthStartDate: moment().add(-7, 'day').format('YYYY-MM-DD'),
      monthEndDate: moment().format('YYYY-MM-DD'),
      timeStartDate: moment().add(-1, 'day').format('YYYY-MM-DD'),
    },
    lang: {
      days: ['일', '월', '화', '수', '목', '금', '토'],
      months: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ],
      yearFormat: 'YYYY년',
      monthFormat: 'MM월',
      // the calendar title of month before year
      monthBeforeYear: false,
    },
    infoDialog: {
      dialog: false,
      title: '',
      content: '',
    },
    isActive: {
      day: 'none',
      week: 'none',
      month: 'none',
      time: 'none',
    },
    isEndActive: {
      day: 'none',
      week: 'none',
      month: 'none',
      time: 'none',
    },
    meetingList: [],
    allMeeting: [],
    usageRoomList: [],
    attendingInfoDialog: {
      dialog: false,
      meeting: null,
    },
    roomUsageMeetings: [],
    /* 회의 통계 그래프 */
    priorityData: [{ value: 0, name: 'No Data...' }],
    color: Material,
    colorDefined: {
      codec: '#60584c',
      pcMobile: '#ffbc00',
      codecPcMobile: '#f46600',
    },
    timeMeetingData: range(0, 24).map((i) => {
      return { time: i };
    }),
    weekDayMeetingData: dayShortNames.map((i) => {
      return { weekDay: i };
    }),
    dayMeetingData: range(1, 32).map((i) => {
      return { day: i };
    }),
    monthMeetingData: shortMonth.map((m) => {
      return { month: m };
    }),

    confTypeMeetingData: range(1, 32).map((i) => {
      return { day: i };
    }),
  }),
  computed: {
    filterLimitMeeting() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.meetingList.slice(startPage, limitPage);
    },
    filterLimitUsageRoom() {
      let page = this.usageRoomPage;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.usageRoomList.slice(startPage, limitPage);
    },
  },
  watch: {
    'filter.startDate': {
      handler(val) {
        // endDate를 1주일 후로 설정.
        this.filter.endDate = moment(val).add(1, 'week').format('YYYY-MM-DD');
      },
    },
  },
  created() {
    this.init();
  },
  async activated() {
    if (!Util.hasSession(this)) return;
    if (this.$store.state.user.authorize !== 'a') {
      this.$router.push('/');
    }
    this.init();
  },
  methods: {
    init() {
      this.filter.startDate = moment().add(-7, 'day').format('YYYY-MM-DD');
      // this.filter.endDate = moment().format('YYYY-MM-DD');
      this.activeChanged();
    },
    meetingUsageSearch() {
      /* 회의 사용 조회 > 검색 */
    },
    meetingStatisticsSearch() {
      /* 회의통계 > 검색 */
    },
    sortDate() {
      if (this.dateSort === 'asc') {
        this.dateSort = 'desc';
        this.meetingList.sort((a, b) => {
          return a.startDtime > b.startDtime
            ? -1
            : b.startDtime > a.startDtime
            ? 1
            : 0;
        });
      } else {
        this.dateSort = 'asc';
        this.meetingList.sort((a, b) => {
          return a.startDtime < b.startDtime
            ? -1
            : b.startDtime < a.startDtime
            ? 1
            : 0;
        });
      }
    },
    sortDept() {
      if (this.deptSort === 'asc') {
        this.deptSort = 'desc';
        this.meetingList.sort((a, b) => {
          return a.creator.department > b.creator.department
            ? -1
            : b.creator.department > a.creator.department
            ? 1
            : 0;
        });
      } else {
        this.deptSort = 'asc';
        this.meetingList.sort((a, b) => {
          return a.creator.department < b.creator.department
            ? -1
            : b.creator.department < a.creator.department
            ? 1
            : 0;
        });
      }
    },
    async activeChanged() {
      this.meetingUsageTab = false;
      this.meetingStatistics = false;
      this.meetingTermList = false;
      this.messengerMeetingUsageTab = false;

      this.statisticsList.forEach((element) => {
        element.isActive = false;
      });
      if (this.active === 'meetingInfo') {
        /* 회의 현황 */
        this.searchMeeting();
        this.meetingUsageTab = true;
      } else if (this.active === 'meetingStatistics') {
        /* 회의 통계 */
        this.searchStatictis('day');
        this.searchStatictis('week');
        this.searchStatictis('month');
        this.searchStatictis('time');
        this.meetingStatistics = true;
      } else if (this.active === 'roomMeetingUsage') {
        /* 회의실별 사용량 */
        this.searchUsageRoom();
        let filter = {
          status: 'e',
          startDate: `${moment(
            moment(this.filter.startDate).format('YYYY-MM-DDT00:00:00')
          )
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss')}Z`,
          endDate: `${moment(
            moment(this.filter.endDate).format('YYYY-MM-DDT23:59:59')
          )
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        };

        this.meetingTermList = true;
        await this.searchRoomUsageClick(filter);
        this.loading = false;
      } else if (this.active === 'userMeetingUsage') {
        /* 사용자별 회의 사용량 */
      }
    },

    clearTabs() {
      this.meetingUsageTab = false;
      this.meetingStatistics = false;
      this.meetingTermList = false;
    },
    getRoomMeetingUsageHeaders() {
      return [
        // { text: this.$t('page.statistics.history.company'), value: 'groupName', align: 'center', sortable: false, class: 'header-text' },
        {
          text: this.$t('page.statistics.building'),
          value: 'buildingName',
          align: 'center',
          sortable: false,
          class: 'header-text',
        },
        {
          text: this.$t('page.statistics.room-name'),
          value: 'roomName',
          align: 'center',
          sortable: false,
          class: 'header-text',
        },
        // { text: this.$t('page.statistics.floor'), value: 'floor', align: 'center', sortable: false, class: 'header-text' },
        {
          text: this.$t('page.statistics.capacity'),
          value: 'capacity',
          align: 'center',
          sortable: false,
          class: 'header-text',
        },
        {
          text: this.$t('page.statistics.meeting-room-usage-count'),
          value: 'createdCnt',
          align: 'center',
          sortable: false,
          class: 'header-text',
        },
        {
          text: this.$t('page.statistics.meeting-room-usage-time'),
          value: 'totalDuration',
          align: 'center',
          sortable: true,
          class: 'header-text',
        },
      ];
    },
    searchMeeting() {
      let params = {
        searchMeeting: this.filter.title,
        analyticsCreator: this.filter.creator,
        showCreatorDept: true,
        showPrivated: true,
        status: ['e'],
        sort: 'desc',
        startDate: `${moment(
          moment(this.filter.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(
          moment(this.filter.endDate).format('YYYY-MM-DDT23:59:59')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        isAdmin: true,
      };

      this.dateSort = 'desc';
      this.$http
        .get(`/api/v1/meetings`, { params: params })
        .then((response) => {
          console.log(response);
          this.page = 1;
          this.meetingList = response.data;
          this.allMeeting = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    async searchRoomUsageClick(value) {
      this.loading = true;
      // 검색 클릭 시 첫 페이지로 이동
      this.pagination.page = 1;
      await this.$http
        .get('/api/v1/meetings/getMeetingUsageByRoom', { params: value })
        .then((response) => {
          this.roomUsageMeetings = response.data;

          this.roomUsageMeetings.map((item) => {
            item['floor'] = Util.numberToFloorText(item.floor) + 'F';
            return item;
          });
          this.loading = false;
          // this.loadingDialog.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          // this.loadingDialog.dialog = false;
        });
    },
    showDatePicker(type) {
      if (this.isActive[type] === '') {
        this.isActive[type] = 'none';
      } else {
        this.isActive[type] = '';
      }
    },
    startDateChange(type) {
      if (this.isActive[type] === '') {
        this.isActive[type] = 'none';
      } else {
        this.isActive[type] = '';
      }
    },
    showEndDatePicker(type) {
      if (this.isEndActive[type] === '') {
        this.isEndActive[type] = 'none';
      } else {
        this.isEndActive[type] = '';
      }
    },
    endDateChange(type) {
      if (this.isEndActive[type] === '') {
        this.isEndActive[type] = 'none';
      } else {
        this.isEndActive[type] = '';
      }
    },
    async searchStatictis(type) {
      let startDate = null;
      let endDate = null;
      let value = {};
      if (type === 'day' || type === 'month') {
        startDate =
          type === 'day'
            ? this.filter.dayStartDate
            : this.filter.monthStartDate;
        endDate =
          type === 'day' ? this.filter.dayEndDate : this.filter.monthEndDate;
        value = {
          startDate: `${moment(moment(startDate).format('YYYY-MM'))
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss')}Z`,
          endDate: `${moment(
            moment(startDate).add(1, 'month').format('YYYY-MM')
          )
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss')}Z`,
          siteName: this.$store.state.user.siteName,
          status: 'e',
        };
      } else {
        if (type === 'week') {
          startDate = this.filter.weekStartDate;
          endDate = this.filter.weekEndDate;
        } else if (type === 'time') {
          startDate = this.filter.timeStartDate;
          endDate = this.filter.timeStartDate;
        }
        value = {
          startDate: `${moment(moment(startDate).format('YYYY-MM-DDT00:00:00'))
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss')}Z`,
          endDate: `${moment(moment(endDate).format('YYYY-MM-DDT23:59:59'))
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss')}Z`,
          siteName: this.$store.state.user.siteName,
          status: 'e',
        };
      }

      await this.getMeetingRoomPriority(value);
      // await this.getMeetingRoomChart(value);  // 우선 삭제 ( 데이터가 많을 경우 보여주기 애매함 )
      this.chartRefresh(value, type);
    },
    searchUsageRoom() {
      let params = {
        startDate: `${moment(
          moment(this.filter.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(
          moment(this.filter.endDate).format('YYYY-MM-DDT23:59:59')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
      };
      this.$http
        .get(`/api/v1/meetings/usage/device`, { params: params })
        .then((response) => {
          this.usageRoomPage = 1;
          this.usageRoomList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },

    attendInfo(meeting) {
      this.attendingInfoDialog.dialog = true;
      this.attendingInfoDialog.meeting = meeting;
    },
    closeAttendingInfoDialog(type) {
      this.attendingInfoDialog.dialog = false;
    },
    getFormatter(params) {
      let param = params[0];
      return `${param.name}: ${param['value'][param.seriesName]} ${this.$t(
        'page.statistics.case'
      )}`;
    },
    allowedStartDates(d) {
      return (
        moment(d).format('YYYY-MM-DD') <=
        moment(this.filter.endDate).format('YYYY-MM-DD')
      );
    },
    allowedEndDates(d) {
      return moment(d).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD');
    },
    async getMeetingRoomPriority(params) {
      await this.$http
        .get('/api/v1/meetings/rooms/priority', { params: params })
        .then((response) => {
          const data = response.data;
          const length = data.length;
          if (length < 1) {
            this.$refs.roomsPriorityChart.init();
            return;
          }
          let priorityChartData = [];
          for (let i = 0; i < length; i++) {
            let info = data[i];
            if (i < 5) {
              priorityChartData.push({
                name: info.name, // info['_id'].name,
                value: info.value,
              });
            }
          }
          this.$refs.roomsPriorityChart.pathOption[0][1] = priorityChartData;
          this.$refs.roomsPriorityChart.init();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async chartRefresh(value, type) {
      let filter = value;
      let chartData = null;
      if (type === 'day') {
        filter['period'] = 'type';
        chartData = (
          await this.$http.get('/api/v1/meetings/analytics/chartData', {
            params: filter,
          })
        ).data;
        let dayData = chartData.map((x) => {
          return {
            day: x._id.day,
            type: x._id.type,
            activeCnt: x.activeCnt,
            inactiveCnt: x.inactiveCnt,
          };
        });
        this.chartDataRebind(
          'dayMeetingChart',
          this.getMeetingDayChartData(dayData)
        );
      } else if (type === 'month') {
        filter['period'] = 'month';
        chartData = (
          await this.$http.get('/api/v1/meetings/analytics/chartData', {
            params: filter,
          })
        ).data;
        let monthData = chartData.map((x) => {
          return {
            month: x._id.month,
            type: x._id.type,
            activeCnt: x.activeCnt,
            inactiveCnt: x.inactiveCnt,
          };
        });
        this.chartDataRebind(
          'monthMeetingChart',
          this.getMeetingMonthChartData(monthData)
        );
      } else if (type === 'week') {
        filter['period'] = 'week';
        chartData = (
          await this.$http.get('/api/v1/meetings/analytics/chartData', {
            params: filter,
          })
        ).data;
        let weekData = chartData.map((x) => {
          return {
            week: x._id.week,
            type: x._id.type,
            activeCnt: x.activeCnt,
            inactiveCnt: x.inactiveCnt,
          };
        });
        this.chartDataRebind(
          'weekDayMeetingChart',
          this.getMeetingWeekDayChartData(weekData)
        );
      } else if (type === 'time') {
        filter['period'] = 'hour';
        chartData = (
          await this.$http.get('/api/v1/meetings/getAnalyticsPeakJoinCnt', {
            params: filter,
          })
        ).data;

        // 시간별 최대 값
        this.timeData.max = Math.max(
          ...chartData.map((item) => item.totalJoinCnt)
        );
        // 시간별 평균 값
        let forAverageData = chartData
          .filter((item) => item.totalJoinCnt > 0)
          .map((item) => item.totalJoinCnt);
        this.timeData.average =
          forAverageData.length > 0
            ? forAverageData.reduce((acc, curr) => acc + curr, 0) /
              forAverageData.length
            : 0;

        // 시간별 최소 값
        this.timeData.min = Math.min(
          ...chartData
            .filter((item) => item.totalJoinCnt > 0)
            .map((item) => item.totalJoinCnt)
        );

        this.chartDataRebind(
          'timeMeetingChart',
          this.getMeetingTimeChartData(chartData)
        );
      }
    },
    chartDataRebind(name, data) {
      if (this.$refs[name] === undefined) return;
      this.$refs[name].pathOption[0][1] = data;

      this.$refs[name].clean();
      this.$refs[name].init();
    },
    getMeetingDayChartData(chartData) {
      let data = range(1, 32).map((m, index) => {
        let day = index + 1;
        let temp = {
          일: `${day}일`,
        };
        let findIdx = chartData.findIndex(
          (item) => item.type === 'video' && item.day - 1 === index
        );
        if (findIdx > -1) {
          temp[this.$t('page.statistics.video-meeting')] =
            chartData[findIdx].inactiveCnt;
          temp[this.$t('page.statistics.conf-video-meeting')] =
            chartData[findIdx].activeCnt;
        } else {
          temp[this.$t('page.statistics.video-meeting')] = 0;
          temp[this.$t('page.statistics.conf-video-meeting')] = 0;
        }
        return temp;
      });
      // this.dayMeetingData = data;
      return data;
    },
    getMeetingMonthChartData(chartData) {
      let data = shortMonth.map((m, index) => {
        let temp = {
          month: m,
        };
        let findIdx = chartData.findIndex(
          (item) => item.type === 'video' && item.month - 1 === index
        );
        if (findIdx > -1) {
          temp[this.$t('page.statistics.video-meeting')] =
            chartData[findIdx].inactiveCnt;
          temp[this.$t('page.statistics.conf-video-meeting')] =
            chartData[findIdx].activeCnt;
        } else {
          temp[this.$t('page.statistics.video-meeting')] = 0;
          temp[this.$t('page.statistics.conf-video-meeting')] = 0;
        }
        return temp;
      });
      // this.monthMeetingData = data;
      return data;
    },
    async downloadMeetingLog(meetingKey) {
      console.log(meetingKey);
      let params = {
        meetingKey: meetingKey,
      };

      window.open(
        `/api/v1/meetings/meetingLog?meetingKey=${meetingKey}`,
        '_self'
      );
    },
    getMeetingTimeChartData(chartData) {
      let data = range(0, 24).map((m, index) => {
        let hour = index;
        let temp = {
          hour: `${hour}시`,
        };
        let findIdx = chartData.findIndex((item) => Number(item._id) === index);

        if (findIdx > -1) {
          temp['HW화상기기'] = chartData[findIdx].deviceJoinCnt;
          temp['모바일'] = chartData[findIdx].mobileJoinCnt;
          temp['PC'] = chartData[findIdx].pcJoinCnt;
        } else {
          temp['HW화상기기'] = 0;
          temp['모바일'] = 0;
          temp['PC'] = 0;
        }

        return temp;
      });

      // this.dayMeetingData = data;
      return data;

      // let data = range(0, 24).map((m, index) => {
      //   let temp = {
      //     hour: `${index}${this.$t('page.statistics.oclock')}`,
      //   };
      //   let findIdx = chartData.findIndex(
      //     (item) => item.type === 'video' && item.hour === index
      //   );
      //   if (findIdx > -1) {
      //     temp[this.$t('page.statistics.video-meeting')] =
      //       chartData[findIdx].cnt;
      //   } else {
      //     temp[this.$t('page.statistics.video-meeting')] = 0;
      //   }
      //   return temp;
      // });
      // // this.timeMeetingData = data;
      // return data;
    },
    getMeetingWeekDayChartData(chartData) {
      let data = dayShortNames.map((m, index) => {
        let temp = {
          weekDay: m,
        };
        let findIdx = chartData.findIndex(
          (item) => item.type === 'video' && item.week - 1 === index
        );
        if (findIdx > -1) {
          temp[this.$t('page.statistics.video-meeting')] =
            chartData[findIdx].inactiveCnt;
          temp[this.$t('page.statistics.conf-video-meeting')] =
            chartData[findIdx].activeCnt;
        } else {
          temp[this.$t('page.statistics.video-meeting')] = 0;
          temp[this.$t('page.statistics.conf-video-meeting')] = 0;
        }
        return temp;
      });
      // this.weekDayMeetingData = data;
      return data;
    },
    getMeetingTypeChartData(chartData) {
      let data = dayShortNames.map((m, index) => {
        let temp = {
          weekDay: m,
        };
        let findIdx = chartData.findIndex(
          (item) => item.type === 'video' && item.week - 1 === index
        );
        if (findIdx > -1) {
          temp[this.$t('page.statistics.video-meeting')] =
            chartData[findIdx].cnt;
        } else {
          temp[this.$t('page.statistics.video-meeting')] = 0;
        }
        return temp;
      });
      // this.weekDayMeetingData = data;
      return data;
    },
    async exportMeetingList() {
      // let items = [];
      // this.allMeeting.forEach((meeting) => {
      //   items.push({
      //     startDate: Util.formatDate(meeting.startDtime),
      //     meetingTime: `${Util.formatTime(
      //       meeting.startDtime
      //     )} ~ ${Util.formatTime(meeting.endDtime)}`,
      //     type: (meeting.conferenceRoomActive ? '고화질 영상회의' : '일반 영상회의'),
      //     title: meeting.title,
      //     creator: `${
      //       meeting.creator.username
      //         ? meeting.creator.username
      //         : meeting.creator.name
      //     }`,
      //     dept:
      //       meeting.creator.deptFullName !== null
      //         ? meeting.creator.deptFullName
      //         : meeting.creator.department,
      //     attendees: meeting.analytics ? meeting.analytics.attendees : '-',
      //     codec: meeting.analytics ? meeting.analytics.participantType.codec : '-',
      //     actualAttendees: meeting.analytics ? meeting.analytics.participantType.pc : '-',
      //   });
      // });
      // let title = `영상회의 통계_${this.filter.startDate}_${this.filter.endDate}`
      // let body = {
      //   title: title,
      //   userId: this.$store.state.user.empNum,
      //   items: items,
      //   type: 'stastics'
      // }
      // await this.$http.post('/api/v1/meetings/ksd/adminListToDocument', body).then((response) => {
      //   if (response) {
      //     alert(`문서중앙화로 전송 완료 - 파일위치 : 스마트회의 관리자/${title}.xlsx`);
      //   }
      // }).catch((error) => {
      //   console.log(error);
      // });
      let title = `영상회의 통계_${this.filter.startDate}_${this.filter.endDate}`;
      let columns = [
        {
          header: this.$t('page.statistics.meeting-date'),
          key: 'startDate',
          width: 15,
        },
        {
          header: this.$t('page.statistics.meeting-time'),
          key: 'meetingTime',
          width: 15,
        },
        // { header: this.$t('page.statistics.meeting-type'), key: 'type', width: 15 },
        {
          header: this.$t('page.statistics.meeting-name'),
          key: 'title',
          width: 35,
        },
        {
          header: this.$t('page.statistics.creator'),
          key: 'creator',
          width: 15,
        },
        { header: this.$t('page.statistics.dept'), key: 'dept', width: 30 },
        // { header: this.$t('page.statistics.mobile'), key: 'mobile', width: 15 },
        // { header: this.$t('page.statistics.pc'), key: 'pc', width: 15 },
        {
          header: this.$t('page.statistics.attendees'),
          key: 'attendees',
          width: 15,
        },
        {
          header: this.$t('page.statistics.actual-attendees'),
          key: 'actualAttendees',
          width: 15,
        },
        { header: '유형', key: 'type', width: 15 },
      ];

      let items = [];
      this.allMeeting.forEach((meeting) => {
        items.push({
          startDate: Util.formatDate(meeting.startDtime),
          meetingTime: `${Util.formatTime(
            meeting.startDtime
          )} ~ ${Util.formatTime(meeting.endDtime)}`,
          // type: (meeting.isOpenConference ? '예약' : '열린 회의실'),
          title: meeting.title,
          creator: `${meeting.creator.username}`,
          dept:
            meeting.creator.deptFullName !== null
              ? meeting.creator.deptFullName
              : meeting.creator.department,
          // mobile: meeting.analytics.participantType.mobile,
          // pc: meeting.analytics.participantType.pc,
          attendees: meeting.analytics ? meeting.analytics.attendees : '-',
          actualAttendees: meeting.analytics
            ? meeting.analytics.participantType.pc
            : '-',
          type: meeting.conferenceRoomActive === true ? '고화질' : '일반',
        });
      });
      console.log(items);

      Util.exportExcel(title, columns, items, true, `${title}.xlsx`);
    },
    exportUsageRoomList() {
      let columns = [
        {
          header: this.$t('page.statistics.company'),
          key: 'company',
          width: 35,
        },
        {
          header: this.$t('page.statistics.building'),
          key: 'building',
          width: 35,
        },
        {
          header: this.$t('page.statistics.room-name'),
          key: 'roomName',
          width: 55,
        },
        {
          header: this.$t('page.statistics.meeting-room-usage-count'),
          key: 'count',
          width: 20,
        },
        {
          header: this.$t('page.statistics.meeting-room-usage-time'),
          key: 'time',
          width: 25,
        },
      ];

      let items = [];
      this.usageRoomList.forEach((item) => {
        items.push({
          company: item.companyName,
          building: item.buildingName,
          roomName: item.roomName,
          count: item.createdCnt,
          time: item.totalDuration,
        });
      });

      Util.exportExcel(
        'Meeting Room Usage List',
        columns,
        items,
        true,
        'Meeting Room Usage List.xlsx'
      );
    },
    async downloadRecord(meetingKey) {
      console.log(meetingKey);
      // TODO: 로딩바 시작
      // TODO: 녹취록 다운 버튼 비활성화

      let params = {
        meetingKey: meetingKey,
      };
      let hasError = false;
      await this.$http
        .get(`/api/v1/meetings/meetingRecord?meetingKey=${meetingKey}`)
        .then((res) => {
          try {
            let file_path = res.data.path;
            if (file_path === undefined) {
              alert('녹취록 파일 없음');
              return false;
            }
            console.log('filePath : ' + file_path);
            let a = document.createElement('A');
            a.href = file_path;
            a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } catch (e) {
            console.error(e);
            hasError = true;
          }
        })
        .catch(function (error) {
          hasError = true;
          console.error(error);
        });
      // TODO: 로딩바 제거
      // TODO: 녹취록 다운 버튼 활성화
      if (hasError) this.downloadFailed(`page.join-meeting.download-fail`);
    },
    downloadFailed(msg) {
      this.infoDialog.title = this.$t('page.join-meeting.download-fail');
      this.infoDialog.content = this.$t(msg);
      this.infoDialog.dialog = true;
    },
    closeInfoDialog() {
      this.infoDialog.title = '';
      this.infoDialog.content = '';
      this.infoDialog.dialog = false;
    },
    disabledTodayAndFuture(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date >= today;
    },
    onStartDateChange(date) {
      if (date) {
        const nextWeek = new Date(date);
        nextWeek.setDate(nextWeek.getDate() + 7);
        this.filter.weekEndDate = moment(nextWeek).format('YYYY-MM-DD');
      } else {
        this.filter.weekEndDate = null;
      }
    },
    notBeforeStartDate(date) {
      return date < new Date(this.filter.weekStartDate);
    },
  },
};
</script>
<style scoped>
.analytics-btn:hover,
.warning-delete-btn {
  background: #464775;
  color: #fff;
}
.analytics-btn {
  width: 130px;
  height: 45px;
  border-radius: 7px;
  font-weight: 300;
  font-size: 13px;
  text-align: center;
  line-height: 45px;
  background: #fff;
  border: 1px solid #464775;
  cursor: pointer;
  color: #464775;
  float: left;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/sections/Statistics.vue